import handlePayment from "../helpers/payment";

async function PaymentComponent(
  orderDetails,
  HandlePaymentSuccess,
  HandlePaymentFailure
) {
  const paymentStatus = await handlePayment(orderDetails);

  if (paymentStatus?.status === 200) {
    HandlePaymentSuccess(paymentStatus?.response);
  } else HandlePaymentFailure();
}

export default PaymentComponent;
